import React, { useEffect, useState } from 'react';
import '../styles/Gallery.css';

import img1 from '../assets/img/1.jpg';
import img2 from '../assets/img/2.jpg';
import img3 from '../assets/img/3.jpg';
import img4 from '../assets/img/4.jpg';
import img5 from '../assets/img/5.jpg';
import img6 from '../assets/img/6.jpg';
import img7 from '../assets/img/7.jpg';
import img8 from '../assets/img/8.jpg';

const IMAGES: string[] = [img1, img2, img3, img4, img5, img6, img7, img8];

type Props = {
    onClose: () => void;
};

const GalleryOverlay: React.FC<Props> = ({ onClose }) => {
    const [selected, setSelected] = useState<string | null>(null);

    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                if (selected) setSelected(null);
                else onClose();
            }
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [selected, onClose]);

    return (
        <div className="gallery-overlay" role="dialog" aria-modal="true">
            <div className="overlay-content">
                <button className="overlay-close" onClick={onClose}>×</button>
                <h2 className="section-title text-center mb-3">Mūsų darbai</h2>
                <p className="section-sub text-center mb-4">Atrinktos nuotraukos iš įvykdytų projektų.</p>
                <div className="gallery-grid">
                    {IMAGES.map((src, i) => (
                        <img
                            key={i}
                            src={src}
                            alt={`baldas-${i}`}
                            loading="lazy"
                            onClick={() => setSelected(src)}
                        />
                    ))}
                </div>
            </div>

            {selected && (
                <div className="lightbox" onClick={() => setSelected(null)}>
                    <img className="lightbox-img" src={selected} alt="Padidinta nuotrauka" />
                </div>
            )}
        </div>
    );
};

export default GalleryOverlay;
